import {
	EdgerRollPass,
	EdgerRollPassResponse,
} from "@/pages/catalogs/models/EdgerRoll";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Roll } from "../models/Roll";

type Props = {
	sectionId: number | null | undefined;
	standId: number | null | undefined;
};

export const getReadyRolls = async (params: Props, signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.sectionId)
		parameters.push({ name: "SectionId", value: params.sectionId });
	if (params.standId)
		parameters.push({ name: "StandId", value: params.standId });

	const resp = await apiService.callV2("[M2].[GetRolls]", parameters, signal);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []) as Roll[];
		const rolls = get(
			resp,
			"data.tables[1].rows",
			[],
		) as EdgerRollPassResponse[];

		const groupPasses = (edgerRollPartId: number): EdgerRollPass[] => {
			const passMap = new Map<number, EdgerRollPass>();

			rolls
				.filter((r) => r.EdgerRollPartId === edgerRollPartId)
				.forEach((r) => {
					if (!passMap.has(r.PassNumber)) {
						passMap.set(r.PassNumber, {
							PassNumber: r.PassNumber,
							PassStatusCode: r.PassStatusCode,
							IsDiagonal: !!r.IsDiagonal,
							StatusDescription: r.StatusDescription,
							Sections: [],
						});
					}

					const pass = passMap.get(r.PassNumber);
					if (pass && r.SectionId && r.SectionName) {
						pass.Sections.push({
							SectionId: r.SectionId,
							SectionName: r.SectionName,
						});
					}
				});

			return Array.from(passMap.values());
		};

		return rows.map((roll) => ({
			...roll,
			Passes: groupPasses(roll.PartId),
		}));
	} else {
		throw new Error(resp.message || "Error fetching rolls");
	}
};
